import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import EkoElement from "@/utilities/element";
import { getSafeTag, type Tag } from "@/utilities/html";
import style from "./avatar.css?inline";

@customElement("eko-avatar")
class Avatar extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true }) alt?: string;
  @property({ reflect: true }) as: Tag = "span";
  @property({ reflect: true }) initials?: string;
  @property({ reflect: true, type: Boolean }) interactive: boolean = false;
  @property({ reflect: true }) size: "xs" | "sm" | "md" | "lg" | "xl" | "2xl" = "md";
  @property({ reflect: true }) src?: string;
  @property({ reflect: true }) variant: "default" | "square" = "default";

  private renderMedia() {
    if (this.src) {
      return html`<img
        alt=""
        class="eko-avatar__image"
        part="image"
        role="presentation"
        src=${this.src} />`;
    }

    if (this.initials) {
      return html`<span class="eko-avatar__initials" part="initials">${this.initials}</span>`;
    }

    return html`<eko-icon class="eko-avatar__fallback" name="plus" part="fallback"></eko-icon>`;
  }

  render() {
    return html`
      ${this.interactive
        ? html`
            <button class="eko-avatar" part="avatar">
              <div aria-label=${ifDefined(this.alt)} role="img">
                ${this.renderMedia()}
                <slot name="indicator"></slot>
              </div>
            </button>
          `
        : html`
            <div aria-label=${ifDefined(this.alt)} class="eko-avatar" part="avatar" role="img">
              ${this.renderMedia()}
              <slot name="indicator"></slot>
            </div>
          `}
    `;
  }

  get tag() {
    return getSafeTag(this.as);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-avatar": Avatar;
  }
}

export default Avatar;
